/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

export const policyOptionAboutMeConfig = {
  policyOption: [
    {
      title: 'Preamble (Term Life Insurance)',
      description: [
        'It is observed that during the last few years,there has been an increased customer preference towards pure term life insurance products. In line with this growing demand, the Life Insurers have been introducing innovative protection products, with different features,options, riders, etc. .',
        'There are many term products in the market with varying terms and conditions. Customers who cannot devote adequate time and energy to make informed choices find it difficult to select the right product. Also, products may not be available for the intended sum assured. To take care of this situation and to make available a product by all Life Insurers that will broadly meet the needs of an average customer, it is felt necessary to introduce a standard, individual term life insurance product, with simple features and standard terms and conditions. Such a standard product will make it easier for the customers to make an informed choice, enhance the trust between the Insurers and the insured, and reduce mis-selling as well as potential disputes at the time of claim settlement.',
        'Therefore, in exercise of powers under Section34 (1) (a) of the Insurance Act, all Life Insurers are directed to offer the following product mandatorily.',
      ],
    },
    {
      title: 'The Standard Term Life Insurance Product',
      description: [
        'The standard individual term life insurance product shall be called, “Saral Jeevan Bima”; the Insurer’s name shall be prefixed to the product name.',
        '“Saral Jeevan Bima” is a non-linked non-participating individual pure risk premium life insurance plan, which provides for payment of Sum Assured in lump sum to the nominee in case of the Life Assured’s unfortunate death during the policy term.',
        'Apart from the benefits and riders stated in the Annexure, no other riders / benefits/ options / variants shall be offered. There shall be no exclusions under the product other than the suicide exclusion.',
        'The product shall be offered to individuals without restrictions on gender, place of residence, travel, occupation or educational qualifications.',
        'The Insurers shall have to file the product as per the above parameters and incompliance with the extant regulatory provisions through File and Use (F&U). The policy document and the terms and conditions of the Standard Product shallbe in the format specified in Annexure -1 to this Circular.',
      ],
    },
    {
      title: 'What is the Sum Assured ? ',
      description: 'Minimum ₹1,00,000 and Maximum ₹5,00,000',
    },
    {
      title: 'What is the Policy Term (in years)?',
      description: '5 to 40 years',
    },
    {
      title: 'What is the Premium Payment Options ? ',
      description: [
        'Regular Premium',
        ' Limited Premium Payment Term for 5 years and 10 years',
        'Single Premium',
      ],
    },
    {
      title: 'What are the policy Benefits (Death Benefit) ?',
      description: [
        'For Regular & Limited Premium Payment policies: Highest of:',
        '10 times of annualized premium',
        '105% of all the premiums paid as on the date of death',
        'Absolute amount assured to be paid on death.',
        'For Single premium policies: Higher of:',
        '125% of single premium',
        'absolute amount assured to be paid on death.',
      ],
    },
    {
      title: 'What are the Maturity Benefit ? ',
      description: 'There shall be no maturity benefit under the policy.',
    },
    {
      title: 'Policy Exclusions ?',
      description: 'Only suicide clause, as per extant regulations.',
    },
    {
      title: 'Waiting Period',
      description: [
        '45 days from the date of commencement of risk. In case of revival of Policy, the Waiting Period shall not be applicable.',
        'The following words shall be prominently displayed in BOLD, on the welcome letter of Policy Document as well as on the first page of Sales Literature.',
        'This Policy will cover death due to accident only during the waiting period of 45 days from the date of commencement of risk.',
        'In case of death of the life assured other than due to accident during the waiting period, an amount equal to 100% of all premiums received excluding taxes, if any, shall be paid and the Sum Assured shall not be paid.',
      ],
    },
    {
      title: 'Surrender Value',
      description: 'Surrender Value is not applicable under this Policy.',
    },
    {
      title: 'Policy Cancellation Value',
      description:
        'No policy cancellation value shall be payable in respect of regular premium policies.',
    },
    {
      title: 'Loan options',
      description: 'No loan will be allowed against the policy',
    },
    {
      title: 'Interest on delayed payment of premiums',
      description:
        'The rate of interest on delayed payment of premiums shall be as per the Insurer’s policy for similar products.',
    },
  ],
  kycForm: [
    {
      title: 'Why do I need to provide this information?',
      description:
        'This information is used to complete your policy application',
    },
  ],
  preview: [
    {
      title: 'FHP Policy Options Table',
      image:
        'https://s3.ap-south-1.amazonaws.com/io.klefki.parametro/table-1-parametro.jpg',
    },
    {
      title: 'FHP Coverage Box 1, 2, 3',
      image: 'https://i.ibb.co/NsnLR6T/bo-image.png',
    },
  ],
  intendedPurpose: [
    {
      title: 'Insuring your home? ',
      description:
        'Please be aware that if you have a separate insurance policy protecting your home, the amount you receive from this policy might be deducted from any payout you receive under that other policy.',
    },
    {
      title: 'What if you already have home insurance?',
      description: 'It won’t in any way affect your payout under this policy.',
    },
  ],
  termsOfUse: [
    {
      title: 'Why do I need to provide this information?',
      description:
        'This Information is required to satisfy regulatory requirements to complete your application for coverage',
    },
    {
      title: 'Why Politically Exposed Person is required? ',
      description:
        'This Information is required to satisfy regulatory requirements to complete your application for coverage',
    },
    {
      title: 'Have you been charged?',
      description:
        'This Information is required to satisfy regulatory requirements to complete your application for coverage',
    },
  ],
};
